import { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';

import NewClientPortal from './NewClientPortal';
import getClientConnect from '../../../../images/getClientConnect.png';
import StateContext from '../../context/State';
import PortalDataService from '../../services/portal.service';
import LearnMoreComponent from '../../components/LearnMoreComponent';

const Initiate = () => {
    const { state } = useContext(StateContext);
    const dataService = new PortalDataService(state);
    
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalLearnMore, setShowModalLearnMore] = useState<boolean>(false);
    const [contactInformationSet, setContactInformationSet] = useState<boolean>(false);

    const isAbleToCreatePortal = async () => {
        try {
            const isAbleResponse = await dataService.ableToCreatePortal();
            setContactInformationSet(isAbleResponse)
        } catch (e) {
            console.log('Unable to get info on whether or not a CP can be made: ', e)
        }
    }
    // eslint-disable-next-line
    useEffect(() => { isAbleToCreatePortal(); }, [])

    return (
        <>
            <div className="margin-bottom">
                <img src={getClientConnect} className="addClientConnect" alt='not-found'></img>
            </div>

            {contactInformationSet ? '' : [
                'warning',
            ].map((variant) => (
                <Alert key={variant} variant={variant}>
                    Client contact information must be set to initiate ClientConnect.
                </Alert>
            ))}

            <Alert>
                <Button
                    variant='primary'
                    disabled={!contactInformationSet}
                    onClick={() => setShowModal(true)}
                >
                    Initiate ClientConnect
                </Button>
                <Button
                    variant='outline-primary'
                    onClick={() => setShowModalLearnMore(true)}
                >
                    Learn More About ClientConnect
                </Button>
            </Alert>

            <NewClientPortal
                showModal={showModal}
                onHideModal={() => setShowModal(false)}
            />
            <LearnMoreComponent
                showModalLearnMore={showModalLearnMore}
                onHideModal={() => setShowModalLearnMore(false)}
                province={ dataService.getProvince() }
            />
        </>
    );
}

export default Initiate;
